// Reason codes that make sense for re-homing a record onto another
// household — a subset of the canonical change_reason_codes enum. One
// list, read by the Cleanup card's confirm step and by
// MoveRecordHouseholdModal, so the two can never disagree.
export const MOVE_REASON_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: "data_quality_cleanup", label: "Data cleanup / stranded by a split" },
  { value: "married_couple_consolidation", label: "Household restructure (marriage/divorce)" },
  { value: "compliance_correction", label: "Compliance correction" },
  { value: "other_with_text", label: "Other (explain below)" },
];
